module.exports = __webpack_public_path__ + "static/media/toyota-icon-noneOption.ce8c3cbd.svg";